import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getTableSelection } from "../../ducks/table/selectors";
import { updateTableSelection } from "../../ducks/table/table";

import { TableSelection } from "../../ducks/table/types";

export const useTableSelection = (): [
  Record<string, TableSelection>,
  (value: Record<string, TableSelection>) => void,
] => {
  const dispatch = useDispatch();
  const tableSelection = useSelector(getTableSelection);

  const setTableSelection = useCallback(
    (value: Record<string, TableSelection>) => {
      dispatch(updateTableSelection(value));
    },
    [dispatch],
  );

  return [tableSelection, setTableSelection];
};
